<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense dark elevation="0" color="primary">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon> -->
                        <span>苗の追加</span>
                    </v-list-item-title>
                    <TitleButton
                        icon="mdi-floppy"
                        name="追加"
                        @click="onClickSave()" />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <!-- 編集用 -->
                    <v-form ref="form">
                        <v-row >
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    v-model="editItems.date"
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <VarietySelector 
                                    v-model="editItems.variety" 
                                    :crops="crops" />
                            </v-col>
                            <v-col>
                                <!-- <v-text-field 
                                    v-model="editItems.num" 
                                    clearable 
                                    label="苗数" 
                                    outlined
                                    dense
                                    type="number" 
                                    suffix="苗" 
                                    prepend-icon="mdi-sprout"/> -->
                                <NumInput 
                                    v-model="editItems.num" 
                                    clearable
                                    suffix="苗"
                                    label="苗数" 
                                    outlined
                                    hide-details 
                                    dense
                                    align="align-left" />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <PlaceSelector 
                                    v-if="places != null && places.length > 0" 
                                    v-model="editItems.placeID" 
                                    dense
                                    :places="places" 
                                    :placeGroups="placeGroups"/>
                            </v-col>
                            <v-col>
                                <v-text-field 
                                    v-if="places == null || editItems.placeID == null" 
                                    v-model="editItems.placeName" 
                                    clearable 
                                    dense
                                    label="場所" 
                                    item-text="text" 
                                    outlined />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-tooltip bottom color="teal lighten-4 black--text">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="editItems.name" 
                                            clearable 
                                            label="苗の名前" 
                                            type="text"
                                            dense
                                            outlined
                                            hide-details />
                                    </template>
                                    <span v-if="editItems.name == null || editItems.name == ''">
                                        何も入力されていない時は、システムが自動で命名します。
                                    </span>
                                    <span v-else>
                                        名前の中に @ を含めると<br/>
                                        それが連番になります。<br/>
                                        例えば、苗数=10, 開始=1 で 名前に "苗_@" と入力すると<br/>
                                        苗_1～苗_10 が作成されます。
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-col>
                                <NumInput 
                                    v-model="editItems.seqStartNo" 
                                    clearable
                                    label="連番の開始番号"
                                    outlined
                                    hide-details 
                                    type="text" 
                                    dense
                                    align="align-left" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select 
                                    v-model="editItems.state" 
                                    label="状態" 
                                    outlined 
                                    dense
                                    :items="states" 
                                    item-text="text" 
                                    item-value="value"/>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.memo" 
                                    clearable 
                                    label="メモ" 
                                    outlined 
                                    type="text" 
                                    counter="50"
                                    :rules="[validatorMemoLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import PlaceSelector from '@/components/seedling/items/SelectorPlace';
    import VarietySelector from '@/components/seedling/items/SelectorVariety';
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    export default {
        components: {
            PlaceSelector,
            VarietySelector,
            DatePicker,
            TitleButton,
            Confirm,
            NumInput
        },
        props: {
            places: {
                type: Array,
                default: null
            },
            placeGroups: {
                type: Array,
                default: null
            },
            crops: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                isView: false,
                states: [
                    {value: 1, text:"育苗中"},
                    {value: 2, text:"栽植中"},
                ],
                editItems: {
                    date: this.df_currentDateTime("yyyy-MM-dd"),
                    variety: null,
                    placeID: null,
                    placeName: "",
                    num: 0,
                    state: 1,
                    memo: "",
                    name: null,
                    seqStartNo: 1
                },
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        methods: {
            onClickSave: function () {
                const userUID = this.$store.getters["userUID"]
                const self = this
                if (!this.$refs.form.validate()) {
                    this.$refs.confirm.show({
                        title: "入力エラー",
                        message: "入力項目を確認して下さい。",
                        width: 400,
                        buttonYes: "入力に戻る",
                        buttonNo: "",
                    })
                    return
                }
                this.$refs.confirm.show({
                    title: "苗",
                    message: "苗を登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("days").doc(self.editItems.date).get().then(function(doc){
                            var managementData = doc.data()
                            self.register(managementData)
                        })
                        return true
                    },
                })
            },
            register: function (managementData) {
                console.log("register", managementData, this.editItems)

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 管理データが存在しない時は、新規に作成
                if (managementData == null) {
                    managementData = {
                        date: this.editItems.date,
                        varieties: []
                    }
                }

                // 管理データから、選択された品種のデータを取得
                // 存在しない時は、新規に作成
                var varietyManagementData = null        
                if (managementData != null) {
                    const index = managementData.varieties.findIndex((v)=>v.cropID == this.editItems.variety.cropID && v.varietyID == this.editItems.variety.varietyID)
                    
                    console.log(this.editItems)

                    var isNewManagementData
                    if (index < 0) {
                        varietyManagementData = {
                            cropID: this.editItems.variety.cropID,
                            varietyID: this.editItems.variety.varietyID,
                            lastSeqNo: 0
                        }
                        managementData.varieties.push(varietyManagementData)
                    } else {
                        varietyManagementData = managementData.varieties[index]
                    }
                }

                // 場所が未選択で、かつ手入力されている時
                var newPlace = null
                if (this.editItems.placeID == null && this.editItems.placeName.length > 0) {
                    var newPlaceID = 1
                    if (this.places != null && this.places.length > 0) {
                        newPlaceID = Math.max(...this.places.map(m => m.placeID)) + 1
                    }
                    newPlace = {
                        // version: "1.0.0",
                        // placeID: newPlaceID,
                        // name: this.editItems.placeName,
                        // register: {
                        //     userUID: userUID,
                        //     dateTime: this.df_currentDateTime()
                        // },
                        // updater: {
                        //     userUID: "",
                        //     dateTime: ""
                        // }
                        version: "1.0.0",
                        placeID: newPlaceID,
                        cultivationType: null,
                        name: this.editItems.placeName,
                        details: {
                            area: 0,
                            variety: {
                                cropID: 1,
                                varietyID: 1
                            }
                        },
                        address: {
                            postalCode: "",
                            pref: "",
                            city: "",
                            address1: "",
                            address2: "",
                            areaID: ""
                        },
                        placeGroupID: "",
                        isDeleted: false,
                        streamingURLs: [],
                        image: null,
                        groupUserAuthorities: ["browse", "work", "environment"],
                        managementAgrichemical: {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            },
                        },
                        memo: "",
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                    this.editItems.placeID = newPlaceID
                }

                // 登録処理開始
                try {
                    var registeredSeedlings = []
                    var batch = db.batch()
                    // 苗
                    for (var i=1; i<=this.editItems.num; i++) {
                        const seqNo = varietyManagementData.lastSeqNo + i
                        const id = this.editItems.date + "-" + ("000" + this.editItems.variety.cropID).slice(-3) + "-" + ("000" + this.editItems.variety.varietyID).slice(-3) + "-" + ("000" + seqNo).slice(-3)
                        const customNameSeqNo = (this.editItems.seqStartNo * 1) + i - 1
                        const customName = this.editItems.name == null || this.editItems.name == "" ? id : this.editItems.name.replace("@", customNameSeqNo+"")

                        const seedling = {
                            varsion: "1.0.0",
                            seedlingID: id,
                            name: customName,
                            parentSeedling: {
                                seedlingID: "",
                                place: null,
                                date: ""
                            },
                            generationNo: 1,
                            childNo: 0,
                            variety: {
                                cropID: this.editItems.variety.cropID,
                                varietyID: this.editItems.variety.varietyID,
                            },
                            state: this.editItems.state,
                            currentPlace: this.editItems.placeID,
                            placeHistories: [
                                {
                                    type: 1,
                                    place: this.editItems.placeID,
                                    date: this.editItems.date,
                                    dateTime: this.df_currentDateTime(),
                                    userUID: userUID,
                                }
                            ],
                            childNum: 0,
                            results: {
                                harvestedNum: 0,
                                observatedNum: 0,
                                workedNum: 0,
                                seedling: {
                                    userUID: "",
                                    startDate: "",
                                    place: null
                                },
                                planting: {
                                    userUID: "",
                                    startDate: "",
                                    place: null
                                }
                            },
                            memo: this.editItems.memo,
                            register: {
                                userUID: userUID,
                                dateTime: this.df_currentDateTime()
                            },
                            updater: {
                                userUID: "",
                                dateTime: ""
                            }
                        }
                        switch (this.editItems.state) {
                            case 1:
                                seedling.results.seedling = {
                                    userUID: userUID,
                                    startDate: this.editItems.date,
                                    place: this.editItems.placeID
                                }
                                break;
                            case 2:
                                seedling.results.planting = {
                                    userUID: userUID,
                                    startDate: this.editItems.date,
                                    place: this.editItems.placeID
                                }
                                break
                        }
                        console.log(seedling)
                        registeredSeedlings.push(seedling)
                        batch.set(db.collection("users").doc(userUID).collection("seedlings").doc(seedling.seedlingID), seedling)
                    }
                    // 管理データ
                    varietyManagementData.lastSeqNo += (this.editItems.num * 1)
                    batch.set(db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("days").doc(this.editItems.date), managementData)

                    // 場所
                    if (newPlace != null) {
                        batch.set(db.collection("users").doc(userUID).collection("places").doc(""+newPlace.placeID), newPlace)
                        this.$store.commit(
                            "managementItems/addUserPlace",
                            {
                                userUID: userUID,
                                placeData: this.$store.getters["managementItems/loggedInUserPlaceData"], 
                                place: newPlace
                            }
                        )
                    }

                    // コミット
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"苗を登録しました。"})
                        if (newPlace != null) {
                            self.$emit("onRegisteredNewPlace", newPlace)
                        }
                        self.$emit("onRegisteredSeedlings", registeredSeedlings)
                        self.isView = false
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"苗の登録に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"苗の登録に失敗しました。", isError:true})
                }
            },
            show: function () {
                this.isView = true
            },
        }
    }
</script>
